export default "__VITE_ASSET__BEasqQ8K__"